import { Emitter } from "./Emitter";
export class NotificationsService {
    constructor() {
        this.notifications = new Emitter();
    }
    notify(title, message, color = 'info', icon) {
        this.notifications.emit({ title, message, color, icon });
    }
    success(title, message, icon = 'check') {
        this.notify(title, message, 'success', icon);
    }
    error(title, message, icon = 'exclamation-octagon-fill') {
        this.notify(title, message, 'danger', icon);
    }
}
